(() => {
  const configElement = document.getElementById('mbl-recharge-copy');
  if (!configElement) return;
  const { copy, currency, locale } = JSON.parse(configElement.textContent);
  const bindings = new Map();
  const initializedWidgets = new WeakSet();
  let scheduled = false;
  const text = (element, value) => {
    if (element && element.textContent.trim() !== value) element.textContent = value;
  };
  const attribute = (element, name, value) => {
    if (element && element.getAttribute(name) !== value) element.setAttribute(name, name === 'aria-label' ? value.trim() : value);
  };
  const directText = (element, value) => {
    const node = element && [...element.childNodes].find(child => child.nodeType === 3 && child.nodeValue.trim());
    if (node && node.nodeValue.trim() !== value) node.nodeValue = value;
  };
  const normalizeMoney = value => currency === 'USD'
    ? value.replace(/\$\s*(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})(?!\d)/g, (_, whole, cents) => '$' + Number(whole.replaceAll('.', '')).toLocaleString('en-US') + '.' + cents)
    : value;
  const style = (root, id, css) => {
    if (!root || root.getElementById(id)) return;
    const element = document.createElement('style');
    element.id = id;
    element.textContent = css;
    root.append(element);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  };
  const observe = root => {
    if (!root || bindings.has(root)) return;
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'rc-selected', 'value', 'data-state', 'aria-expanded', 'shell-ready'] });
    root.addEventListener('change', schedule, true);
    root.addEventListener('input', schedule, true);
    bindings.set(root, observer);
  };
  const selectOneTimeByDefault = (widget, root) => {
    if (initializedWidgets.has(widget)) return;
    const oneTime = root.querySelector('input[name="purchaseOption"][value="onetime"]');
    if (!oneTime) return;
    initializedWidgets.add(widget);
    widget.dataset.mblPurchaseDefault = 'onetime';
    if (!oneTime.checked && !oneTime.disabled) oneTime.click();
  };
  const frequency = value => value.replace(/\b(?:días|days)\b/gi, copy.days).replace(/\b(?:Ahorra|Save)\b/gi, copy.save);
  const prices = widget => {
    const root = widget.shadowRoot;
    const section = widget.closest('.shopify-section');
    const dataElement = section?.querySelector('[data-mbl-selling-plan-prices]');
    if (!dataElement) return;
    const productId = widget.getAttribute('product-id');
    if (dataElement.dataset.mblSellingPlanPrices !== productId) return;
    const form = section.querySelector(`product-form-component[data-product-id="${productId}"] form[action*="/cart/add"]`);
    const variantId = form?.querySelector('[name="id"]')?.value;
    const data = JSON.parse(dataElement.textContent);
    const variant = data[variantId];
    if (!variant) return;
    const selected = root.querySelector('input[name="purchaseOption"]:checked');
    if (!selected) return;
    const subscription = selected.value === 'subscription';
    section.classList.toggle('mbl-selected-subscription', subscription);
    const plansRoot = root.querySelector('rc-selling-plans')?.shadowRoot;
    const planId = plansRoot?.querySelector('select')?.value || form.querySelector('[name="selling_plan"]')?.value;
    const current = subscription ? variant.allocations[planId] : variant;
    if (!current) return;
    const nativePrice = root.querySelector('[part="rc-purchase-option__price"]')?.textContent.trim();
    if (nativePrice && normalizeMoney(nativePrice).replace(/\s/g, '') !== variant.formatted.replace(/\s/g, '')) return;
    const containers = section.querySelectorAll(`product-price[data-product-id="${productId}"] [ref="priceContainer"], sticky-add-to-cart[data-product-id="${productId}"] [ref="priceContainer"]`);
    containers.forEach(container => {
      const regular = container.querySelector('.price__regular');
      const sale = container.querySelector('.price__sale');
      if (!regular || !sale) return;
      const showCompare = current.compare > current.price;
      regular.classList.toggle('price__hidden', showCompare);
      sale.classList.toggle('price__hidden', !showCompare);
      text(regular.querySelector('.price'), current.formatted);
      text(sale.querySelector('.price-item--sale'), current.formatted);
      text(sale.querySelector('.compare-at-price'), current.compareFormatted);
      if (typeof current.packUnitText === 'string') {
        text(container.querySelector('.mbl-pack-unit-price'), current.packUnitText);
      }
      let note = container.querySelector('.mbl-purchase-price-note');
      if (!note) {
        note = document.createElement('small');
        note.className = 'mbl-purchase-price-note';
        note.style.cssText = 'display:block;font-size:.75rem;line-height:1.4;font-weight:400;margin-top:4px';
        container.append(note);
      }
      const selectedOption = plansRoot?.querySelector('select')?.selectedOptions[0];
      const interval = selectedOption?.textContent.split(':')[0].trim();
      text(note, subscription ? (interval ? `${copy.frequency} ${frequency(interval)}` : copy.perDelivery) : copy.onetime);
    });
  };
  const widgetCopy = widget => {
    const root = widget.shadowRoot;
    if (!root) return;
    observe(root);
    selectOneTimeByDefault(widget, root);
    style(root, 'mbl-recharge-responsive-fix', '.compact .rc-purchase-option__label{column-gap:12px}.compact .rc-purchase-option__selector{flex:1 1 auto;min-width:0;flex-wrap:wrap}.compact .rc-purchase-option__selector rc-learn-more{flex:0 0 auto;line-height:1.25!important;margin-left:.5rem;white-space:nowrap}.compact .rc-purchase-option__prices{flex:0 0 auto;margin-left:0}');
    text(root.querySelector('legend'), copy.legend);
    directText(root.querySelector('input[value="subscription"]')?.closest('.rc-purchase-option__selector'), copy.subscription);
    directText(root.querySelector('input[value="onetime"]')?.closest('.rc-purchase-option__selector'), copy.onetime);
    root.querySelectorAll('.visually-hidden').forEach(element => {
      if (/^(Original price|Precio original)/i.test(element.textContent.trim())) text(element, copy.original);
      else if (/(Discounted price|Precio con descuento)/i.test(element.textContent)) text(element, copy.discounted);
    });
    root.querySelectorAll('.rc-price').forEach(element => [...element.childNodes].filter(n => n.nodeType === 3).forEach(n => {
      const next = normalizeMoney(n.nodeValue);
      if (next !== n.nodeValue) n.nodeValue = next;
    }));
    const learnRoot = root.querySelector('rc-learn-more')?.shadowRoot;
    if (learnRoot) {
      observe(learnRoot);
      style(learnRoot, 'mbl-recharge-learn-more-fix', '.rc-learn-more.compact,.rc-learn-more.compact .rc-learn-more__trigger{line-height:1.25!important}.rc-learn-more__trigger{white-space:nowrap!important}');
      const trigger = learnRoot.querySelector('.rc-learn-more__trigger');
      text(trigger, copy.learnMore);
      attribute(trigger, 'aria-label', copy.learnMore);
      learnRoot.querySelectorAll('[aria-label="Close"], [aria-label="Cerrar"]').forEach(e => attribute(e, 'aria-label', copy.close));
    }
    const plansRoot = root.querySelector('rc-selling-plans')?.shadowRoot;
    if (plansRoot) {
      observe(plansRoot);
      text(plansRoot.querySelector('.rc-plans__label'), copy.frequency);
      attribute(plansRoot.querySelector('select'), 'aria-label', copy.frequency);
      plansRoot.querySelectorAll('option').forEach(option => {
        [...option.childNodes].filter(n => n.nodeType === 3).forEach(n => {
          const next = frequency(n.nodeValue);
          if (next !== n.nodeValue) n.nodeValue = next;
        });
      });
    }
    prices(widget);
  };
  const exact = new Map();
  const aliases = {
    close:['Close','Cerrar'], remove:['Remove','Eliminar'], increase:['Increase quantity','Aumentar cantidad'], decrease:['Decrease quantity','Disminuir cantidad'], quantity:['Quantity','Cantidad'], current:['Current price','Precio actual'], afterDiscount:['Price after discount','Precio con descuento'], previous:['Previous product','Producto anterior'], next:['Next product','Producto siguiente'],
    onetime:['One-time purchase','Compra única'], frequency:['Deliver every','Envíos cada'], upgrade:['Mejora a subscripción','Mejora a suscripción','Upgrade to subscription','Cambiar a suscripción'], upgrading:['Upgrading to subscription...','Cambiando a suscripción...'], cart:['Cart','Tu carrito','Your cart'], checkout:['FINALIZAR COMPRA','CHECKOUT'], add:['Agregar','Add'], recommendations:['También puedes necesitar','You may also need'], freeShipping:['🎉 Felicidades ya tienes envío gratis!','🎉 ¡Felicidades, ya tienes envío gratis!','🎉 Congratulations, you have free shipping!'], congratulations:['Felicidades','Congratulations'], freeShippingEnding:['ya tienes envío gratis!','you have free shipping!'], empty:['Your cart is empty','Tu carrito está vacío'], continueShopping:['Continue shopping','Seguir comprando'], subtotal:['Subtotal'], total:['Total'], discountCode:['Discount code','Código de descuento'], apply:['Apply','Aplicar']
  };
  Object.entries(aliases).forEach(([key, values]) => values.forEach(value => exact.set(value, copy[key])));
  const translate = value => {
    const trimmed = value.trim();
    if (exact.has(trimmed)) return value.replace(trimmed, exact.get(trimmed));
    if (/^(Original price|Precio original):?$/.test(trimmed)) return copy.original.replace(/:$/, '') + (trimmed.endsWith(':') ? ':' : '');
    if (/^(Original price|Precio original):\s*\$/.test(trimmed)) return normalizeMoney(trimmed.replace(/^(Original price|Precio original):/, copy.original));
    if (/^(Current price|Precio actual):\s*\$/.test(trimmed)) return normalizeMoney(trimmed.replace(/^(Current price|Precio actual):/, copy.current + ':'));
    if (/^(Price after discount|Precio con descuento):\s*\$/.test(trimmed)) return normalizeMoney(trimmed.replace(/^(Price after discount|Precio con descuento):/, copy.afterDiscount + ':'));
    if (/^(Remove|Eliminar)\s+/.test(trimmed)) return trimmed.replace(/^(Remove|Eliminar)/, copy.remove);
    if (/^(Tu carrito|Your cart)\s*\(\d+\)$/.test(trimmed)) return trimmed.replace(/^(Tu carrito|Your cart)/, copy.cart);
    let match = trimmed.match(/^(?:Saving|Ahorras)\s+([\d.,]+%)$/);
    if (match) return copy.saving.replace('{discount}', match[1]);
    match = trimmed.match(/^(\d+) day subscription with ([\d.,]+%) discount$/);
    if (match) return `${copy.frequency} ${match[1]} ${copy.days}: ${copy.save} ${match[2]}`;
    match = trimmed.match(/^(?:Mejora a subscripción y ahorra hasta|Suscríbete y ahorra hasta|Subscribe and save up to|Cambiar a suscripción y ahorrar hasta|Switch to subscription and save up to)\s+([\d.,]+%)$/);
    if (match) return copy.upgradeSaving.replace('{discount}', match[1]);
    match = trimmed.match(/^Subscribe and buy (\d+), save ([\d.,]+%)!$/) || trimmed.match(/^Suscríbete y compra (\d+), ¡ahorra ([\d.,]+%)!$/);
    if (match) return copy.quantitySaving.replace('{quantity}', match[1]).replace('{discount}', match[2]);
    if (/^\d+\s+(days|días)(?:\s*[:—-].*)?$/.test(trimmed)) return frequency(value);
    return normalizeMoney(value);
  };
  const cartCopy = root => {
    observe(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      if (node.parentElement?.closest('style,script,textarea')) return;
      const next = translate(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    });
    root.querySelectorAll('[aria-label],[placeholder]').forEach(element => {
      ['aria-label','placeholder'].forEach(name => {
        const value = element.getAttribute(name);
        if (value) attribute(element, name, translate(value));
      });
    });
    root.querySelectorAll('*').forEach(element => { if (element.shadowRoot) cartCopy(element.shadowRoot); });
  };

  // Only option values are translated; product names and option data remain intact.
  const cartOptions = root => {
    if (!locale?.startsWith('es')) return;
    root.querySelectorAll('[role="listitem"] dl').forEach(list => {
      list.querySelectorAll('dt,dd,p').forEach(element => {
        const value = element.textContent.trim();
        if (/^packs?:?$/i.test(value)) text(element, copy.packLabel + (value.endsWith(':') ? ':' : ''));
        else if (/^size:?$/i.test(value)) text(element, copy.sizeLabel + (value.endsWith(':') ? ':' : ''));
        else {
          const match = value.match(/^(\d+)[ -]+packs?$/i) || value.match(/^pack of (\d+)$/i);
          if (match) text(element, match[1] + ' ' + (Number(match[1]) === 1 ? copy.unit : copy.units));
        }
      });
    });
  };
  const cartPurchaseMode = root => {
    root.querySelectorAll('#cart-drawer section[role="list"] > [role="listitem"]').forEach(item => {
      // Recharge shows its upgrade control only for a one-time line item.
      const upgrade = [...item.querySelectorAll('button')].find(button =>
        button.textContent.trim() === copy.upgrade ||
        /^(?:Cambiar a suscripción y ahorrar hasta|Switch to subscription and save up to)\s+[\d.,]+%$/.test(button.textContent.trim()));
      let label = item.querySelector('[data-mbl-cart-purchase-mode]');
      if (!upgrade) { label?.remove(); return; }
      if (!label) {
        label = document.createElement('p');
        label.setAttribute('data-mbl-cart-purchase-mode', '');
        label.style.cssText = 'margin:0 0 6px;font-size:14px;font-weight:600;line-height:1.4';
        upgrade.before(label);
      }
      text(label, copy.onetime);
    });
  };
  const positionChat = () => {
    const chat = document.querySelector('shopify-chat');
    const root = chat?.shadowRoot;
    if (!root) return;
    const runtime = root.querySelector('shopify-agent-runtime');
    const chatRoots = [root, runtime?.shadowRoot].filter(Boolean);
    for (const chatRoot of chatRoots) {
      observe(chatRoot);
      style(chatRoot, 'mbl-chat-cart-clearance',
      ':host([data-mbl-drawer-open]) .activator-nudge{visibility:hidden!important;pointer-events:none!important}' +
      ':host([data-mbl-cart-page]) .activator-nudge{left:16px!important;right:auto!important}' +
      '@media(max-width:749px){:host([data-mbl-cart-page]) .activator-nudge{bottom:var(--mbl-chat-cart-bottom,120px)!important}' +
      ':host([data-mbl-cart-page]) .activator__label{display:none!important}' +
      ':host([data-mbl-product-docked]) .activator-nudge{bottom:max(var(--mbl-chat-product-bottom,120px),calc(120px + env(safe-area-inset-bottom,0px)))!important}' +
      ':host([data-mbl-product-docked]) .activator__label{display:none!important}}');
    }
    const chatHosts = [chat, runtime].filter(Boolean);
    const toggleChatAttribute = (name, value) => chatHosts.forEach(host => host.toggleAttribute(name, value));
    const drawer = document.getElementById('recharge-storefront-experiences__cart-drawer');
    const open = Boolean(drawer?.shadowRoot?.querySelector('#CartSheet[data-state="open"]') ||
      document.querySelector('cart-drawer-component dialog[open]'));
    toggleChatAttribute('data-mbl-drawer-open', open);
    const cartPage = Boolean(document.querySelector('main[data-template="cart"]'));
    toggleChatAttribute('data-mbl-cart-page', cartPage);
    const productPage = Boolean(document.querySelector('main[data-template^="product"]'));
    const productBar = productPage
      ? document.querySelector('sticky-add-to-cart [data-stuck="true"]')
      : null;
    toggleChatAttribute('data-mbl-product-docked', Boolean(productBar));
    if (productBar && window.innerWidth <= 749) {
      // Clear the full bar, including wrapped price/purchase-mode labels.
      const bottom = Math.ceil(window.innerHeight - productBar.getBoundingClientRect().top + 16);
      const next = bottom + 'px';
      if (chat.style.getPropertyValue('--mbl-chat-product-bottom') !== next) {
        chat.style.setProperty('--mbl-chat-product-bottom', next);
      }
    }
    if (!cartPage || open || window.innerWidth > 749) return;
    const launcher = chatRoots.map(chatRoot => chatRoot.querySelector('.activator-nudge')).find(Boolean);
    const payments = document.querySelector('.cart__ctas');
    if (!launcher || !payments) return;
    const payRect = payments.getBoundingClientRect();
    const height = launcher.getBoundingClientRect().height;
    const naturalBottom = window.innerHeight - 120;
    const overlaps = payRect.bottom > naturalBottom - height - 16 && payRect.top < naturalBottom + 16;
    const bottom = overlaps ? Math.max(120, Math.min(window.innerHeight - height - 16, window.innerHeight - payRect.top + 16)) : 120;
    const next = bottom + 'px';
    if (chat.style.getPropertyValue('--mbl-chat-cart-bottom') !== next) chat.style.setProperty('--mbl-chat-cart-bottom', next);
  };

  function refresh() {
    for (const [root, observer] of bindings) {
      if (!(root.host || root).isConnected) {
        observer.disconnect();
        root.removeEventListener('change', schedule, true);
        root.removeEventListener('input', schedule, true);
        bindings.delete(root);
      }
    }
    document.querySelectorAll('recharge-subscription-widget').forEach(widgetCopy);
    const cart = document.getElementById('recharge-storefront-experiences__cart-drawer');
    if (cart?.shadowRoot) {
      cartCopy(cart.shadowRoot);
      cartOptions(cart.shadowRoot);
      cartPurchaseMode(cart.shadowRoot);
    }
    positionChat();
  }
  const relevantRootSelector =
    'recharge-subscription-widget, #recharge-storefront-experiences__cart-drawer, cart-drawer-component, shopify-chat';
  const containsRelevantRoot = node =>
    node instanceof Element &&
    (node.matches(relevantRootSelector) || Boolean(node.querySelector(relevantRootSelector)));
  const discovery = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(containsRelevantRoot))) schedule();
  });
  discovery.observe(document.body, { childList: true, subtree: true });
  ['variant:update','shopify:section:load','cart:update'].forEach(event => document.addEventListener(event, schedule));
  document.addEventListener('click', event => {
    const target = event.target;
    if (target instanceof Element && target.closest(relevantRootSelector)) schedule();
  }, true);
  let chatFrame = false;
  const scheduleChat = () => {
    if (chatFrame) return;
    chatFrame = true;
    requestAnimationFrame(() => { chatFrame = false; positionChat(); });
  };
  window.addEventListener('scroll', scheduleChat, { passive: true });
  window.addEventListener('resize', scheduleChat);
  window.addEventListener('mbl:sticky-cart-visibility', scheduleChat);
  customElements.whenDefined('shopify-chat').then(schedule);
  customElements.whenDefined('shopify-agent-runtime').then(schedule);
  customElements.whenDefined('recharge-subscription-widget').then(schedule);
  [0,750,2000].forEach(delay => setTimeout(schedule, delay));
})();

